import { Grid, InputAdornment, Slider, TextField } from "@mui/material";
import { GRID_ROW } from "./FormulaCard";
import { isUndefined } from "portal/utils/identity";
import { numberOrEmptyString } from "portal/utils/forms";
import { TVEProfile } from "protos/target_velocity_estimator/target_velocity_estimator";
import { useTranslation } from "react-i18next";
import React, { Dispatch, FunctionComponent, SetStateAction } from "react";

interface Props {
  label: string;
  description: string;
  field: keyof TVEProfile;
  tveProfile: TVEProfile;
  setUpdatedTve: Dispatch<SetStateAction<TVEProfile | undefined>>;
  disabled?: boolean;
}

export const SmoothingInputSlider: FunctionComponent<Props> = ({
  label,
  description,
  field,
  tveProfile,
  setUpdatedTve,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <Grid {...GRID_ROW} key={field}>
      <Grid
        className="order-1 font-bold"
        size={{
          xs: 12,
          md: 2,
        }}
      >
        {label}
      </Grid>
      <Grid
        className="order-3 flex flex-col items-center md:order-2"
        size={{
          xs: 12,
          md: 2,
        }}
      >
        <TextField
          size="small"
          disabled={disabled}
          type="number"
          value={(() => {
            const value = tveProfile[field];
            return typeof value === "number"
              ? Math.round(Number(value) * 100)
              : value;
          })()}
          className="w-full text-center"
          onChange={(event) => {
            const value = numberOrEmptyString(event.target.value);
            setUpdatedTve({
              ...tveProfile,
              [field]: typeof value === "number" ? value / 100 : value,
            });
          }}
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            },

            htmlInput: { min: 0, max: 100 },
          }}
        />
      </Grid>
      <Grid
        className="order-2 text-sm md:order-3"
        size={{
          xs: 12,
          md: 8,
        }}
      >
        {description}
      </Grid>
      {/* Slider */}
      <Grid className="order-4 p-10" size={12}>
        <Slider
          track={false}
          min={0}
          max={100}
          disabled={disabled}
          classes={{
            mark: "hidden",
          }}
          value={(() => {
            const value = tveProfile[field];
            return typeof value === "number"
              ? Math.round(Number(value) * 100)
              : undefined;
          })()}
          onChange={(__, value) => {
            setUpdatedTve({
              ...tveProfile,
              [field]: isUndefined(value) ? value : Number(value) / 100,
            });
          }}
          marks={[
            {
              value: 0,
              label: t("components.velocityEstimator.slider.gradual"),
            },
            { value: Number(tveProfile[field]) * 100 },
            {
              value: 100,
              label: t("components.velocityEstimator.slider.immediate"),
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};
